import _classCallCheck from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";

var OAuthWindowBase = /*#__PURE__*/function () {
  function OAuthWindowBase(_ref) {
    var _this = this;

    var provider = _ref.provider,
        url = _ref.url,
        session = _ref.session,
        _ref$w = _ref.w,
        w = _ref$w === void 0 ? window : _ref$w;

    _classCallCheck(this, OAuthWindowBase);

    this.provider = provider;
    this.url = url;
    this.session = session;
    this.headerKeys = session.headerKeys;
    this.hasAuthenticated = new Promise(function (resolve, reject) {
      _this.resolve = resolve;
      _this.reject = reject;
    });
    this.open(w);
  }

  _createClass(OAuthWindowBase, [{
    key: "open",
    value: function open() {
      this.reject('OAuthWindow: openProviderWindow not defined');
    }
  }]);

  return OAuthWindowBase;
}();

export { OAuthWindowBase as default };